// Pure (no DOM) shaping for the GID-95 sync-change-summary block: turns the
// backend's { groups, hasFailures } shape (see extractToolCallSummary in
// messageRenderDecisions.js) into display strings. Kept separate from
// messageRenderDecisions.js because that module answers "what should
// render" while this one answers "how is it worded" -- the same split this
// codebase already uses for usage display (usageDisplay.js's
// formatUsageRows() vs. the account-panel decision logic).

function itemKindNoun(itemKind, count) {
  const base = String(itemKind || "item").replace(/_/g, " ");
  return count === 1 ? base : `${base}s`;
}

/**
 * @param {Array<{label: string, item_kind: string, count: number}>} groups
 * @returns {string} e.g. "Added 1 hammock task, 8 tasks · Updated 1 task"
 */
export function buildCoarseSummaryLine(groups) {
  const order = [];
  const partsByLabel = new Map();
  for (const g of groups) {
    if (!partsByLabel.has(g.label)) {
      partsByLabel.set(g.label, []);
      order.push(g.label);
    }
    partsByLabel.get(g.label).push(`${g.count} ${itemKindNoun(g.item_kind, g.count)}`);
  }
  return order.map((label) => `${label} ${partsByLabel.get(label).join(", ")}`).join(" · ");
}

/**
 * @param {Array<{label: string, item_kind: string, count: number, names: string[], truncated: boolean}>} groups
 * @returns {Array<{label: string, text: string}>}
 */
export function buildDetailLines(groups) {
  return groups.map((g) => {
    const noun = itemKindNoun(g.item_kind, g.count);
    if (!g.names || g.names.length === 0) {
      return { label: g.label, text: `${g.count} ${noun}` };
    }
    let text = g.names.join(", ");
    if (g.truncated && g.count > g.names.length) {
      text += `, and ${g.count - g.names.length} more`;
    }
    if (g.item_kind !== "task") {
      text += ` (${noun})`;
    }
    return { label: g.label, text };
  });
}
